import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.closeButton = this.el.querySelector('.js-banner-top-close');

        if (this.closeButton) {
            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeBanner();
            });
        }

        if (this.get_cookie('close_banner_top')) {
            document.documentElement.classList.add('has-banner-top-closed');
            return;
        }
    }

    set_cookie(name, value) {
        document.cookie = `${name}=${value}; path=/`;
    }

    get_cookie(name) {
        const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }
    closeBanner() {
        document.documentElement.classList.add('has-banner-top-closed');
        this.set_cookie('close_banner_top', 'true');
    }

    destroy() {
        if (this.closeButton) {
            this.closeButton.removeEventListener('click', this.closeBanner);
        }
    }
}
